import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { string, ref } from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Tooltip,
  Avatar,
  FormHelperText,
} from "@mui/material";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import { useMutation } from "@apollo/client";
//Icons
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import EmptyImage from "../../Assets/empty-image.png";
import { AuthContext } from "../../Context/AuthContext";
import { UPDATE_LEVEL_SECTION } from "../../Schema/LevelSection";


export default function UpdateSection({
  open,
  handleClose,
  setRefetch,
  editData,
}) {
  // Change Language
  // const { language } = useContext(AuthContext);
  // const { t } = translateLauguage(language);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  // const [role, setRole] = useState("ប្រធានក្រុមប្រឹក្សា");
  const [userValue, setUserValue] = useState({ title: "", id: "" });

  // ========================= upload Image =========================
  const [profileHook, setProfileHook] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [photoURL, setPhotoURL] = useState(null);
  const [openCrop, setOpenCrop] = useState(false);


  // ======================= Progress ==============================
  const [statusProgress, setStatusProgress] = useState(false);
  const [progress, setProgress] = useState(10);
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 100 : prevProgress + 10
      );
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, []);
  // ===================== End progress =============================

  const [updateLevelSection] = useMutation(UPDATE_LEVEL_SECTION, {
    onCompleted: ({ updateLevelSection }) => {
      setLoading(false); 
      if (updateLevelSection?.status) {
        setAlert(true, "success", updateLevelSection?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else { 
        setAlert(true, "error", updateLevelSection?.message);
      }
    },
    onError: (error) => { 
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    levelSectionKhName: Yup.string().required("require!"),
    levelSectionEnName: Yup.string().required("require!"),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
        remark: "",
        levelSectionKhName: "",
        levelSectionEnName: ""
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => { 
      setLoading(true);
      updateLevelSection({
        variables: {
          id: editData?._id,
          input: {
            ...values
          },
        },
      });
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData) {
      setFieldValue("levelSectionKhName", editData?.levelSectionKhName);
      setFieldValue("levelSectionEnName", editData?.levelSectionEnName);
      setFieldValue("remark", editData?.remark);      
    }
  }, [editData,open]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              កែប្រែផ្នែក
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={6}>
                <Typography className="field-title">ផ្នែកជាខ្មែរ</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="ផ្នែកជាខ្មែរ"
                  {...getFieldProps("levelSectionKhName")}
                  error={Boolean(touched.levelSectionKhName && errors.levelSectionKhName)}
                  helperText={touched.levelSectionKhName && errors.levelSectionKhName}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography className="field-title">ផ្នែកជាអង់គ្លេស</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="ផ្នែកជាអង់គ្លេស"
                  {...getFieldProps("levelSectionEnName")}
                  error={Boolean(touched.levelSectionEnName && errors.levelSectionEnName)}
                  helperText={touched.levelSectionEnName && errors.levelSectionEnName}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">Remark</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={3}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>
              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                    disabled={statusProgress && progress < 100 ? true : false}
                  >
                    កែប្រែ
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
